/** @format */

export const projects = [
  {
    title: "ISEE Video Stream",
    subtitle: "MERN",
    description:
      "It's an academic project that involves setting up an online video application enabling users to download videos Watch videos Comment and chat live with other people.",
    image: "./3Proj-isee-gif.gif",
    link: "https://github.com/daadaamed/Isee-video-stream-project",
    tags: ["React", "Node", "MongoDB", "JS"],
  },
  {
    title: "Age and mood live detection",
    subtitle: "Angular",
    description:
      "It's a mini project that uses a face-api library to implement a live estimation of age and mood of the user in front of the camera.",
    image: "./face-api-angular.gif",
    link: "https://stackblitz.com/~/github.com/daadaamed/angular-face-api-age-detection",
    tags: ["Angular"],
  },
  {
    title: "Proximity BeReal",
    subtitle: "Ionic React, Firebase",
    description:
      "An academic project that consists of a cross platform solution for a social network similar to Snapchat allows users to post photos and view their posts based on their location. It also includes a private or group messaging system using React-based Ionic.",
    image: "./proximity-demo.gif",
    link: "https://snapshootdb.web.app/proximity",
    tags: ["Ionic", "React", "Firebase"],
  },
  {
    title: "School management",
    subtitle: "GraphQL with Nest, React, MongoDB, Docker",
    description:
      "This is a school project that aims to produce a web native tool for students and professors within a school using React and GraphQL with a microservice architecture in a monorepo. It manages courses, student enrollment and grades.",
    image: "./agql-demo.gif",
    link: "https://github.com/daadaamed/4AGQL-GraphQL-course-management-project",
    tags: ["GraphQL", "Nest", "React", "MongoDB", "Docker"],
  },
  {
    title: "SMU library management",
    subtitle: "MERN",
    description:
      "SMU Library is a responsive web-based library management system for my University SMU. It coontains admin web app and user web app.",
    image: "./SMU-librarymanagementsystemGIF.gif",
    link: "https://github.com/SMU-Library",
    tags: ["React", "Node", "MongoDB", "JS"],
  },
  {
    title: "Desa Social Media",
    subtitle: "Azure services, React, Nest",
    description:
      "It's an academic project aimed at developing a social network that enables users to post content. It incorporates Azure authentication along with standard authentication (email/password) and CRUD operations for posts and comments.",
    image: "./DESA-azure-react-nest-social-media-app.gif",
    link: "https://github.com/daadaamed/Azure-react-nest-social-media",
    tags: ["Azure services", "React", "Nest"],
  },
  {
    title: "Fleetman vehicule tracker",
    subtitle: "Kubernetes, Linux servers",
    description:
      "This project deploys a Kubernetes cluster for the 'fleetman-vehicle-tracker' web app to track truck deliveries in real time. Derived from a Docker-compose file, Kubernetes manifests are used on a Linux server setup with one master and two worker nodes. It utilizes CRI-O for runtime, kubeadm for initialization, and Calico for networking.",
    image: "./fleetman.png",
    link: "https://github.com/daadaamed/4KUBE-fleetman",
    tags: ["Kubernetes", "Docker", "Linux servers"],
  },
  {
    title: "MetMuseum",
    subtitle: "ReactJS",
    description:
      "MetMuseum is a web application built for an art museum to display its artifacts from the official api of the museum. The interface contains research features and load details of each work.",
    image: "./metmuseumgif.gif",
    link: "https://github.com/daadaamed/3Webd-Museum",
    tags: ["React", "JS"],
  },
  {
    title: "RailRoad",
    subtitle: "Node, Express, MongoDB",
    description:
      "RailRoad is a school project for the backend course. It is an API that aim to produce the best experience for a railway company. We used Postman to test this backend. Click to read more in Github.",
    image: "./railo2.gif",
    link: "https://github.com/daadaamed/Railroad-API",
    tags: ["JS", "Node", "Express", "MongoDB"],
  },
  {
    title: "Tic Tac Toe",
    subtitle: "React",
    description:
      "The famous game tic tac toe, or Xs and Os, built with react for 2 players who take turns marking the spaces in a three-by-three grid with X or O.",
    image: "./ticgif.gif",
    link: "https://github.com/daadaamed/",
    tags: ["React"],
  },
];

export const blogs = [
  {
    id: 0,
    type: "Article",
    image: "../blog_images/software-architecture.png",
    description:
      "You can just start sticking things together, and it might turn out OK. The larger the project, the less likely is your success with this method. If you have a large project, especially a more-than-one-person project, you need to have some idea what you’re building: what the parts are supposed to look like and how they are supposed to fit together. \n \n Otherwise, you end up with a whole lot of code that is just stuck together, and you can’t maintain such a thing without constantly breaking it, no matter how smart you are. In general a good architect will break down a software system into its parts, and each part will be evaluated against these criteria. \n \n All in all, the architecture boils down to whatever is important. Why do we care? Well, any significant system needs to be placed on a solid foundation. If service uptime is a critical feature of the system, then you had best architect a solution that includes failover and disaster recovery. If raw speed is what is important, you may choose to write code that is highly optimized sacrificing some readability/maintainability. Decisions at the architecture level often have long term consequences that can put your application at risk if chosen poorly.",
    title:
      "How important is it to build the architecture of software before writing the code?",
    date: "2024",
    link: "https://medium.com/@daadaamed/how-important-is-it-to-build-the-architecture-of-software-before-writing-the-code-e9c268b432c2",
    tags: ["#SoftwareArchitecture", "#DesignPattern"],
  },
  {
    id: 1,
    type: "Article",
    image: "../blog_images/jwt-flower.png",
    description:
      "A JSON Web Token (JWT) is a compact, secure way of transmitting information between parties. It is made up of three parts — Header, Payload, and Signature — separated by dots (.). Each part serves a specific purpose: the header defines the algorithm and type, the payload carries user claims, and the signature guarantees the token’s integrity and authenticity.",
    title: "JWT token structure explained",
    date: "2025",
    link: "https://medium.com/@daadaamed/how-jwt-works-demo-of-token-creation-and-validation-b80f3e56a030",
    tags: ["#JWT"],
  },
  {
    id: 2,
    type: "Article",
    image: "../blog_images/go.png",
    description:
      "In many Go applications, it is often necessary to run scheduled tasks, for example for maintenance, reporting, or data synchronization. Traditionally, these tasks rely on the system-level cron service. However, this approach comes with several limitations: it depends on the underlying operating system, lacks portability, and is not embedded directly within the Go binary. To overcome these constraints, one solution is to integrate an embedded scheduler directly into the Go application. The goal is to provide a mechanism that is simple, reliable, and independent of the host system. In this context, we introduce the Schedule() function, which allows developers to plan and execute tasks autonomously within a Go program.",
    title: "Building an embedded job scheduler in Go using robfig/cron",
    date: "2025",
    link: "https://medium.com/@daadaamed/building-an-embedded-job-scheduler-in-go-using-robfig-cron-ffaea05f72cb",
    tags: ["#JWT"],
  },
  {
    id: 3,
    type: "Article",
    image: "../blog_images/bigquery.png",
    description:
      "Google BigQuery is a powerful data warehouse, but when developing locally, you often don’t want to hit the real BigQuery service (costs, quotas, etc). That’s where the BigQuery Emulator comes in using this repository",
    title: "Using BigQuery Emulator in Golang: A Simple Guide with Example",
    date: "2025",
    link: "https://medium.com/@daadaamed/using-bigquery-emulator-in-golang-a-simple-guide-with-example-d83e141e7f8a",
    tags: ["#BigQuery"],
  },
  {
    id: 4,
    type: "Article",
    image: "../blog_images/git_icon.png",
    description:
      "Whether you’re a student, junior developer, or switching careers, one tool you’ll find yourself using almost daily is Git. It’s an indispensable version control system that allows teams and individuals to collaborate, track changes, and manage codebases efficiently. I had the opportunity to work within 5 companies as an intern and these are the commands that I think every entry-level developer should know. This is not an exhaustive guide, but it will give you a solid foundation to start using Git confidently.",
    title: "Building an embedded job scheduler in Go using robfig/cron",
    date: "2025",
    link: "https://medium.com/@daadaamed/essential-git-commands-for-entry-level-developers-7055596fb7fb",
    tags: ["#Git"],
  },
  {
    id: 5,
    type: "Article",
    image: "../blog_images/sqlitelogo.png",
    description:
      "SQLite is widely used in applications where a lightweight, self-contained database is neded. However, security concerns arise when handling sensitive data. Encryption is a crucial step in ensuring data protection but it's not provided by default library. In this article, we’ll explore how to encrypt an SQLite database using Pharma with a real-world example.",
    title: "Encrypt database SQLite",
    date: "2025",
    link: "https://medium.com/@daadaamed/encrypt-database-sqlite-using-pharma-real-example-77d6a5f36473",
    tags: ["#Sqlite", "#Encryption"],
  },
];

export const skills = [
  "Golang",
  "TypeScript",
  "React",
  "VueJS",
  "Node & NestJS",
  "Python",
  "SQL(PostgreSQL, SQLite)",
  "NoSQL(MongoDB)",
  "BDD & TDD concepts",
  "Docker & K8s",
  "Linux servers",
  "Agile Methodology",
  "MVVM & MVC architectures",
  "CICD"
];
